import { HttpLoaderFactory } from '../../../application/translation/httpLoaderFactory';
const ɵ0 = HttpLoaderFactory;
export class MonitorsModule {
}
export { ɵ0 };
